import { useState } from 'react';
import { LinkIcon, CheckIcon, CopyIcon } from 'lucide-react';

const Footer: React.FC<{
  handleOnCreateShareLink: () => void;
  handleClear?: () => void;
  shareLink: string | null;
  isCreatingShareLink: boolean;
  disabled: boolean;
}> = ({
  handleOnCreateShareLink,
  handleClear,
  shareLink,
  isCreatingShareLink,
  disabled,
}: {
  handleOnCreateShareLink: () => void;
  handleClear?: () => void;
  shareLink: string | null;
  isCreatingShareLink: boolean;
  disabled: boolean;
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    if (!shareLink) return;

    try {
      await navigator.clipboard.writeText(shareLink);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const openLink = () => {
    if (shareLink) {
      window.open(shareLink, '_blank', 'noopener,noreferrer');
    }
  };

  const buttonStyle = disabled ? 'disabled:opacity-50 ' : 'hover:bg-blue-700';

  return (
    <div className="flex items-center gap-2 justify-between">
      <div className="flex gap-2">
        <button
          onClick={handleClear}
          className="bg-white text-blue-600 hover:bg-blue-50 rounded-md border border-blue-300 transition-colors flex items-center justify-center gap-2 px-[16px] py-[8px] font-semibold text-sm"
        >
          Clear
        </button>
      </div>
      {shareLink ? (
        <>
          <div className="flex items-center gap-3  px-4 py-3">
            <LinkIcon className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-medium text-gray-700">Share Link:</span>
            <div className="flex items-center gap-2">
              <button
                onClick={copyToClipboard}
                className="flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                title="Copy to clipboard"
              >
                {isCopied ? (
                  <>
                    <CheckIcon className="w-4 h-4" />
                    <span>Copied!</span>
                  </>
                ) : (
                  <>
                    <CopyIcon className="w-4 h-4" />
                    <span>Copy</span>
                  </>
                )}
              </button>
              <button
                onClick={openLink}
                className="flex items-center gap-2 px-3 py-1.5 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-md border border-gray-300 shadow-sm hover:shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                title="Open in new tab"
              >
                <LinkIcon className="w-4 h-4" />
                <span>Open</span>
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="flex justify-end gap-2 w-full">
          <button
            onClick={handleOnCreateShareLink}
            disabled={disabled}
            className={`bg-blue-600 text-white  rounded-md transition-colors flex items-center justify-center gap-2 px-[16px] py-[8px] font-semibold text-sm ${buttonStyle}`}
          >
            {isCreatingShareLink ? 'Creating...' : 'Create share link'}
          </button>
        </div>
      )}
    </div>
  );
};

export default Footer;
